// extracted by mini-css-extract-plugin
module.exports = {"container":"display-module--container--3CTr_","homepage":"display-module--homepage--h6iH_"};